import React from 'react';
import { applicationCurrentApplicationSelector } from '@applyboard/ab-common';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
export var ApplicationStepper = connect(createStructuredSelector({
  application: applicationCurrentApplicationSelector
}))(function (_ref) {
  var application = _ref.application,
    ApplicationStepperComponent = _ref.ApplicationStepperComponent;
  if (!application || !ApplicationStepperComponent) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ApplicationStepperComponent, {
    application: application
  });
});